<div class="bg-th-yellow mt-0 container-fluid">

  <div class=" d-flex justify-content-between align-content-center h-35">

    <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

    <span class="my-auto f16 fw-bold me-2"> مدیریت پیمانکاران </span>

  </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- جدول اطلاعات -->

    <div class="border border-2 p-2">

        <div class="row gx-2 gy-md-0 gy-2">

            <!-- اینپوت جستجو -->

            <div class="col-12 col-md-10">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

            <div class="col-12 col-md-auto" *ngIf="accessibility('bSchool_Contractors')">

                <button class="btn btn-success w-100" (click)="openModal()"> 
                    
                    &nbsp; افزودن &nbsp; 

                </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="max-height:calc(100vh - 230px);overflow: auto;">
            
            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th *ngFor="let item of lst_Headers" class="text-center">

                            {{ item.strName }}

                        </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Result; let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class="">

                            <i class="fa fa-edit fa-lg text-primary mx-2 pointer" title=" ویرایش" (click)="openModal(item,i)"></i>

                            <i class="fa fa-trash fa-lg text-danger pointer" title="حذف" (click)="removeItem(item,i)"></i>

                            <i class="fa fa-ellipsis-h fa-lg pointer me-2" aria-hidden="true" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"></i>

                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="z-index: 10001!important;">

                                <!-- مدارس تحت پوشش -->

                                <li class="dropdown-li" (click)="openSchools(item)">

                                    <i class="fa fa-graduation-cap fa-lg" title="مدارس تحت پوشش" aria-hidden="true"></i>
                                        
                                    <span> مدارس تحت پوشش </span>

                                </li>

                                <!-- پرسنل کلیدی -->

                                <li class="dropdown-li" (click)="openPersonnel(item)">

                                    <i class="fa fa-users fa-lg" title="پرسنل کلیدی" aria-hidden="true"></i>
                                        
                                    <span> پرسنل کلیدی </span>

                                </li>
                                
                                <!-- ناوگان پیمانکار -->

                                <li class="dropdown-li" (click)="openFleet(item)">

                                    <i class="fa fa-car fa-lg" title="ناوگان پیمانکار" aria-hidden="true"></i>
                                        
                                    <span> ناوگان پیمانکار </span>

                                </li>

                            </ul>

                        </td>

                        <td> {{ item?.strName | faNum }} </td>

                        <td> {{ item.strRegistrationNumber | faNum }} </td>

                        <td> {{ item.strNationalID | faNum }} </td>

                        <td> {{ item.strTel | faNum }} </td>

                        <td> {{ item.strMobile | faNum }} </td>

                        <td> {{ item.strCityName | faNum }} </td>

                        <td> {{ item.strAddress | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<div class="modal fade" id="AddOrEdit_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-md">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMod ? 'ویرایش' : 'افزودن' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Submit" class="row gx-0 gy-0 p-2">

                    <!-- نام -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> نام </label>

                        <input class="form-control p-2 text-center" formControlName="strName">

                    </div>

                    <!-- نام خانوادگی مدیر عامل -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> * نام خانوادگی مدیر عامل </label>

                        <input class="form-control p-2 text-center" formControlName="strCEOName">

                    </div>

                    <!-- ایمیل -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> ایمیل </label>

                        <input class="form-control p-2 text-center" formControlName="strEmail">

                    </div>

                    <!-- نام مسئول هماهنگی -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> نام مسئول هماهنگی </label>

                        <input class="form-control p-2 text-center" formControlName="strTransportationCoordinatorName">

                    </div>

                    <!-- موبایل مسئول هماهنگی -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> موبایل مسئول هماهنگی </label>

                        <input class="form-control p-2 text-center" formControlName="strTransportationCoordinatorMobile" oninput="this.value = this.value.replace(/[^0-9]/g,'')" maxlength="11">

                    </div>

                    <!-- کد اقتصادی -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> کد اقتصادی </label>

                        <input class="form-control p-2 text-center" formControlName="strEconomicCode">

                    </div>

                    <!-- شناسه ملی -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> شناسه ملی </label>

                        <input class="form-control p-2 text-center" formControlName="strNationalID" oninput="this.value = this.value.replace(/[^0-9]/g,'')" maxlength="11">

                    </div>

                    <!-- شماره ثبت -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> شماره ثبت </label>

                        <input class="form-control p-2 text-center" formControlName="strRegistrationNumber" oninput="this.value = this.value.replace(/[^0-9]/g,'')" maxlength="11">

                    </div>

                    <!-- شماره تلفن -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> شماره تلفن </label>

                        <input class="form-control p-2 text-center" formControlName="strTel">

                    </div>

                    <!-- شماره موبایل -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> شماره موبایل </label>

                        <input class="form-control p-2 text-center" formControlName="strMobile" oninput="this.value = this.value.replace(/[^0-9]/g,'')" maxlength="11">

                    </div>

                    <!-- وضعیت -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> وضعیت </label>

                        <select class="form-select p-2" formControlName="tiStatus">

                            <option class="text-center" value="-1"> انتخاب کنید </option>

                            <option class="text-center" value="0"> ثبت نام </option>

                            <option class="text-center" value="1"> در حال بررسی </option>

                            <option class="text-center" value="2"> نقص مدارک </option>

                            <option class="text-center" value="3"> تایید </option>

                            <option class="text-center" value="4"> تایید </option>
                            
                            <option class="text-center" value="5"> معلق </option>

                        </select>

                    </div>

                    <!-- شهر -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> شهر </label>

                        <custom-filter *ngIf="list_City.length > 0 && showFilter"

                            [strValue]="returnStrValue('strCity',mdl_Submit.get('strCity')?.value,list_City,'strCityName')"
                    
                            [strComment]="'strCityName'"
                    
                            [stylesArray]="['padding-top: 10px','text-align: center']"
                    
                            [str_Placeholder]="'نام شهر را جستجو کنید'"
                    
                            [lst_Main]="list_City" 
                    
                            [lst_SearchKey]="['strCityName']"
                    
                            [isDisabled]="false"
                            
                            (hideOptions)="mdl_Submit.get('strCity')?.setValue($event?.strCity ? $event.strCity : '')">
                
                        </custom-filter>

                    </div>

                    <!-- آدرس -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> آدرس </label>

                        <input class="form-control p-2 text-center" formControlName="strAddress">

                        <button class="btn btn-warning rounded" (click)="show_Map()">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                
                        </button>

                    </div>

                    <!-- مدال نقشه -->

                    <custom-map *ngIf="showCustom_Map"
                    
                        [strValue]="mdl_Map.get('strAddress')?.value"
                
                        [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]"

                        [isOpenModal]="true"

                        (mdl_Submit)="submitMap($event)">
            
                    </custom-map>

                    <!--  مجوز حمل و نقل دانش آموزی -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bStudentTransportation" formControlName="bStudentTransportation">

                        <label class="form-check-label pointer text-muted me-2" for="bStudentTransportation"> مجوز حمل و نقل دانش آموزی </label>

                    </div>

                    <!-- حمل و نقل دانش آموزی -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bStudentTransportation" formControlName="bStudentTransportation">

                        <label class="form-check-label pointer text-muted me-2" for="bStudentTransportation"> حمل و نقل دانش آموزی </label>

                    </div>

                    <!-- حمل و نقل شرکتی -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bCorporateTransportation" formControlName="bCorporateTransportation">

                        <label class="form-check-label pointer text-muted me-2" for="bCorporateTransportation"> حمل و نقل شرکتی </label>

                    </div>

                    <!-- مجوز حمل و نقل عمومی -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bPublicTransportation" formControlName="bPublicTransportation">

                        <label class="form-check-label pointer text-muted me-2" for="bPublicTransportation"> مجوز حمل و نقل عمومی </label>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="submit_Request()">

                    &nbsp; {{ bEditMod ? 'ویرایش' : 'ثبت' }} &nbsp;

                </button>
                
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="schools_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> مدارس تحت پوشش </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="p-2">

                    <div class="row gx-0 gy-0">

                        <div class="col-md-10 col-12">

                            <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list2($event.target)">

                        </div>

                        <div class="col-md-2 col-12 px-md-2">

                            <button class="w-100 btn btn-success" (click)="addSchool()"> 

                                افزودن
                                
                            </button>

                        </div>


                    </div>

                    <div class="section border border-2 mt-2" style="height:47vh;overflow: auto;">

                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                            <thead>

                                <tr class="">

                                    <th class="text-center col-1"> # </th>

                                    <th class="text-center"> عملیات </th>

                                    <th class="text-center"> نام مدرسه </th>

                                    <th class="text-center"> منطقه </th>

                                    <th class="text-center"> مقطع </th>

                                    <th class="text-center"> جنسیت </th>

                                    <th class="text-center"> وضعیت </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="col-12 text-center" *ngFor="let item of list_School;let i = index">

                                    <td>{{ i + 1 | faNum }}</td>

                                    <td class="text-center">

                                        <i class="fa fa-edit fa-lg text-primary mx-2 pointer" title=" ویرایش" (click)="addSchool(item,index)" ></i>

                                        <i class="fa fa-trash fa-lg text-danger pointer" title="حذف" (click)="removeSchool(item,index)"></i>

                                    </td>

                                    <td>{{ item.strName | faNum }}</td>

                                    <td>{{ item.strEducationDistrict_strComment | faNum }}</td>

                                    <td>{{ item.strEducationLevel_strComment | faNum }}</td>

                                    <td>{{ item.strGender | faNum }}</td>

                                    <td>{{ item.strStatus | faNum }}</td>
                
                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>


            </div>

            <div class="modal-footer d-flex justify-content-start">
                
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="personnel_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> پرسنل کلیدی </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="p-2">

                    <div class="row gx-0 gy-0">

                        <div class="col-md-10 col-12">

                            <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list4($event.target)">

                        </div>

                        <div class="col-md-2 col-12 px-md-2">

                            <button class="w-100 btn btn-success" (click)="addPersonnel()"> 

                                افزودن
                                
                            </button>

                        </div>


                    </div>

                    <div class="section border border-2 mt-2" style="height:47vh;overflow: auto;">

                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                            <thead>

                                <tr class="">

                                    <th class="text-center col-1"> # </th>

                                    <th class="text-center"> عملیات </th>

                                    <th class="text-center">  کد ملی </th>

                                    <th class="text-center">  نام </th>

                                    <th class="text-center">  موبایل </th>

                                    <th class="text-center"> سمت </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="col-12 text-center" *ngFor="let item of lstKeyPersonnel;let i = index">

                                    <td>{{ i + 1 | faNum }}</td>

                                    <td class="text-center">

                                        <i class="fa fa-edit fa-lg text-primary mx-2 pointer" title=" ویرایش" (click)="addPersonnel(item,index)" ></i>

                                        <i class="fa fa-trash fa-lg text-danger pointer" title="حذف" (click)="removePersonnel(item,i)"></i>

                                    </td>

                                    <td>{{ item.strID | faNum }}</td>

                                    <td>{{ item.strFullName | faNum }}</td>

                                    <td>{{ item.strMobile | faNum }}</td>

                                    <td>{{ item.strContractor_PersonnelPosition_strComment | faNum }}</td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>


            </div>

            <div class="modal-footer d-flex justify-content-start">
                
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="SchoolAddOrEdit_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-md">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMod ? 'ویرایش' : 'افزودن' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_NewSchool" class="row gx-0 gy-0 p-2">

                    <!-- نام مدرسه -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> نام مدرسه </label>

                        <input class="form-control p-2 text-center" formControlName="strName">

                    </div>

                    <!-- جنسیت -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> جنسیت </label>

                        <select class="form-select p-2" formControlName="tiGender">

                            <option class="text-center" value=""> انتخاب کنید </option>

                            <option class="text-center" value="1"> پسر </option>

                            <option class="text-center" value="2"> دختر </option>

                            <option class="text-center" value="3"> مختلط </option>

                        </select>

                    </div>

                    <!-- وضعیت -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> وضعیت </label>

                        <select class="form-select p-2" formControlName="tiStatus">

                            <option class="text-center" value=""> انتخاب کنید </option>

                            <option class="text-center" value="1"> در حال مذاکره </option>

                            <option class="text-center" value="2"> عدم توافق </option>

                            <option class="text-center" value="3"> در انتظار پاسخ </option>

                            <option class="text-center" value="4"> عقد قرارداد </option>
                            
                        </select>

                    </div>

                    <!-- مقطع تحصیلی -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> مقطع تحصیلی </label>

                        <select class="form-select p-2" formControlName="tiEducationLevel">

                            <option class="text-center" value=""> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of lstLevel_List" [value]="item.tiEducationLevel">

                                {{ item.strComment }}

                            </option>
                            
                        </select>

                    </div>

                    <!-- ناحیه -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> ناحیه </label>

                        <select class="form-select p-2" formControlName="tiEducationDistrict">

                            <option class="text-center" value=""> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of lstDistrict" [value]="item.tiEducationDistrict">

                                {{ item.strComment }}

                            </option>
                            
                        </select>

                    </div>

                    <!-- تعداد دانش آموز سرویس -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> تعداد دانش آموز سرویس </label>

                        <input class="form-control p-2 text-center" formControlName="iNumberStudents">

                    </div>

                    <!-- تعداد ناوگان -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> تعداد ناوگان </label>

                        <input class="form-control p-2 text-center" formControlName="iFleetNumber">

                    </div>

                    <!-- آدرس -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> آدرس </label>

                        <input class="form-control p-2 text-center" formControlName="strAddress">

                        <button class="btn btn-warning rounded" (click)="show_Map2()">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                
                        </button>

                    </div>

                    <!-- مدال نقشه -->

                    <custom-map *ngIf="showCustom_Map2"
                    
                        [strValue]="mdl_Map.get('strAddress')?.value"
                
                        [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]"

                        [isOpenModal]="true"

                        (mdl_Submit)="submitMap($event)">
            
                    </custom-map>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="submit_School()">

                    &nbsp; {{ bEditMod ? 'ویرایش' : 'ثبت' }} &nbsp;

                </button>
                
                <button class="btn btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#schools_Modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="fleetAddOrEdit_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-md">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMod ? 'ویرایش' : 'افزودن' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_NewFleet" class="row gx-0 gy-0 p-2">

                    <!-- تعداد سواری -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> تعداد سواری </label>

                        <input class="form-control p-2 text-end" formControlName="iRides" oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()">

                    </div>

                    <!-- تعداد ون -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> تعداد ون </label>

                        <input class="form-control p-2 text-end" formControlName="iVans" oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()">

                    </div>

                    <!-- تعداد مینی بوس -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> تعداد مینی بوس </label>

                        <input class="form-control p-2 text-end" formControlName="iMinibus" oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()">

                    </div>

                    <!-- تعداد اتوبوس -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> تعداد اتوبوس </label>

                        <input class="form-control p-2 text-end" formControlName="iBuses" oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()">

                    </div>

                    <!-- تعداد ناوگان ملکی شرکت -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> تعداد ناوگان ملکی شرکت </label>

                        <input class="form-control p-2 text-end" formControlName="iCivilianFleets" oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()">

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="submit_Fleet()">

                    &nbsp; {{ bEditMod ? 'ویرایش' : 'ثبت' }} &nbsp;

                </button>
                
                <button class="btn btn-outline-secondary" data-bs-toggle="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="personnelAddOrEdit_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-md">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMod ? 'ویرایش' : 'افزودن' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Personnel" class="row gx-0 gy-0 p-2">

                    <!-- نام و نام خانوادگی -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> نام و نام خانوادگی </label>

                        <input class="form-control p-2 text-center" formControlName="strFullName">

                    </div>

                    <!-- سمت -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> سمت </label>

                        <select class="form-select p-2" formControlName="tiContractor_PersonnelPosition">

                            <option class="text-center" value=""> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of lstPersonnelPosition" [value]="item.tiContractor_PersonnelPosition">

                                {{ item.strComment }}

                            </option>
                            
                        </select>

                    </div>

                    <!-- کد ملی -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> کد ملی </label>

                        <input class="form-control p-2 text-end" formControlName="strID">

                    </div>

                    <!-- موبایل -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> موبایل </label>

                        <input class="form-control p-2 text-end" formControlName="strMobile" oninput="this.value = this.value.replace(/[^0-9]/g,'')" maxlength="11">

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="submit_Personnel()">

                    &nbsp; {{ bEditMod ? 'ویرایش' : 'ثبت' }} &nbsp;

                </button>
                
                <button class="btn btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#personnel_Modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>